const api = "https://api.vstoreae.com";

export default api;
